import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { useAdminAuthStore } from '@/stores/admin-auth.store';

const AdminLayout = () => import('@/layouts/AdminLayout.vue');
const DashboardView = () => import('@/views/admin/DashboardView.vue');
const CustomersView = () => import('@/views/admin/CustomersView.vue');
const CustomerDetailView = () => import('@/views/admin/CustomerDetailView.vue');
const TtsJobDetailView = () => import('@/views/admin/TtsJobDetailView.vue');
const PlansView = () => import('@/views/admin/PlansView.vue');
const SubscriptionsView = () => import('@/views/admin/SubscriptionsView.vue');
const PaymentsView = () => import('@/views/admin/PaymentsView.vue');
const TtsJobsView = () => import('@/views/admin/TtsJobsView.vue');
const TtsCatalogView = () => import('@/views/admin/TtsCatalogView.vue');
const QueueMonitorView = () => import('@/views/admin/QueueMonitorView.vue');
const AuditLogsView = () => import('@/views/admin/AuditLogsView.vue');
const AdminsView = () => import('@/views/admin/AdminsView.vue');
const AdminLoginView = () => import('@/views/admin/AdminLoginView.vue');
const NotFoundView = () => import('@/views/NotFoundView.vue');

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/admin/dashboard' },
  {
    path: '/admin/auth/login',
    name: 'admin-login',
    component: AdminLoginView,
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAdminAuth: true },
    children: [
      { path: '', redirect: { name: 'admin-dashboard' } },
      { path: 'dashboard', name: 'admin-dashboard', component: DashboardView },
      { path: 'customers', name: 'admin-customers', component: CustomersView },
      { path: 'customers/:id', name: 'admin-customer-detail', component: CustomerDetailView },
      { path: 'plans', name: 'admin-plans', component: PlansView },
      { path: 'subscriptions', name: 'admin-subscriptions', component: SubscriptionsView },
      { path: 'payments', name: 'admin-payments', component: PaymentsView },
      { path: 'tts/jobs', name: 'admin-tts-jobs', component: TtsJobsView },
      { path: 'tts/jobs/:id', name: 'admin-tts-job-detail', component: TtsJobDetailView },
      { path: 'tts/catalog', name: 'admin-tts-catalog', component: TtsCatalogView },
      { path: 'queue', name: 'admin-queue', component: QueueMonitorView },
      { path: 'audit-logs', name: 'admin-audit-logs', component: AuditLogsView },
      { path: 'admins', name: 'admin-admins', component: AdminsView },
    ],
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView },
];

const router = createRouter({
  // Không dùng base '/admin' — route đã có tiền tố /admin; base trùng gây Not Found tại /admin/
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, _from, next) => {
  const authStore = useAdminAuthStore();
  const isAuthRoute = to.name === 'admin-login';

  if (isAuthRoute) {
    if (authStore.isAuthenticated) return next({ name: 'admin-dashboard' });
    return next();
  }

  if (to.meta.requiresAdminAuth && !authStore.isAuthenticated) {
    return next({ name: 'admin-login' });
  }

  next();
});

export default router;